/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompassInfoRequest
 */
export interface CompassInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof CompassInfoRequest
     */
    firmware_revision?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompassInfoRequest
     */
    mac_address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompassInfoRequest
     */
    hardware_version?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompassInfoRequest
     */
    battery_percentage?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompassInfoRequest
     */
    compass_alert_mute_status?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompassInfoRequest
     */
    is_compass_core: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompassInfoRequest
     */
    timestamp: number;
}

/**
 * Check if a given object implements the CompassInfoRequest interface.
 */
export function instanceOfCompassInfoRequest(value: object): value is CompassInfoRequest {
    if (!('is_compass_core' in value) || value['is_compass_core'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function CompassInfoRequestFromJSON(json: any): CompassInfoRequest {
    return CompassInfoRequestFromJSONTyped(json, false);
}

export function CompassInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompassInfoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firmware_revision': json['firmware_revision'] == null ? undefined : json['firmware_revision'],
        'mac_address': json['mac_address'] == null ? undefined : json['mac_address'],
        'hardware_version': json['hardware_version'] == null ? undefined : json['hardware_version'],
        'battery_percentage': json['battery_percentage'] == null ? undefined : json['battery_percentage'],
        'compass_alert_mute_status': json['compass_alert_mute_status'] == null ? undefined : json['compass_alert_mute_status'],
        'is_compass_core': json['is_compass_core'],
        'timestamp': json['timestamp'],
    };
}

export function CompassInfoRequestToJSON(json: any): CompassInfoRequest {
    return CompassInfoRequestToJSONTyped(json, false);
}

export function CompassInfoRequestToJSONTyped(value?: CompassInfoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firmware_revision': value['firmware_revision'],
        'mac_address': value['mac_address'],
        'hardware_version': value['hardware_version'],
        'battery_percentage': value['battery_percentage'],
        'compass_alert_mute_status': value['compass_alert_mute_status'],
        'is_compass_core': value['is_compass_core'],
        'timestamp': value['timestamp'],
    };
}

